<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="main-container">
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Send Push Notifications">
          <vs-alert
            :active="!!(warnings && warnings.length)"
            v-for="(warning, index) in warnings" :key="`push_notification_warning_${index}`"
            color="warning"
            icon="warning_outline"
            class="mb-3"
          >
            {{ warning.field }}: {{ warning.text }}
          </vs-alert>
          <div class="vx-row">
            <div class="vx-col w-full">
              <MessageDetailsCard
                v-on:messageChanged="updateMessage">
              </MessageDetailsCard>
            </div>
          </div>
          <div class="vx-row my-2">
            <div class="vx-col w-full">
              <SendToCard
                v-on:userIdsChanged="updateUserIds"
                v-on:notificationTypeChanged="updateNotificationType"
                :filters="filters"
                :disableSend="disableSend"
                :getFilteredUserIds="getFilteredUserIds"
                :userIds="userIds"
                :setIsLoading="setIsLoading"
                :notificationType="notificationType"
                :companies="companies"
              />
            </div>
          </div>
          <div class="vx-row py-2 mb-2 w-full no-gutter">
            <vs-button
              :disabled="disableSend"
              class="mx-2 mb-2"
              color="warning"
              type="filled"
              @click="sendPushes(true)"
            >
              Test Send
            </vs-button>
            <vs-button
              :disabled="disableSend"
              class="mx-2 mb-2"
              color="success"
              icon="send"
              type="gradient"
              icon-after
              @click="confirmAction(`SEND NOTIFICATIONS TO ${userIds.length} USERS & ${fcmTokens.length || '?'} DEVICES`,`Are you sure you want to send this message to potentially ${fcmTokens.length || '?'} devices? This cannot be undone.`,()=> { sendPushes(false); })"
            >
              Send Notifications
            </vs-button>
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base">
        <PushHistory />
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/http/pushApi';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import MessageDetailsCard from './components/MessageDetailsCard';
  import SendToCard from './components/SendToCard';
  import PushHistory from './components/PushHistory';
  import request from '@/http/request';
  import consoleAPI from "@/http/api";

  import helpers from '@/models/helpers';

  export default {
    components: {
      MessageDetailsCard,
      SendToCard,
      PushHistory
    },
    mounted() {
      this.getCompanies();
    },
    data() {
      return {
        request: request,
        jsonHtml: jsonHtml,
        types: types,
        isLoading: false,
        helpers: helpers,
        userIds: [],
        notificationType: 'notification',
        fcmTokens: [],
        message: new types.ComposePushNotificationMessage(),
        disableSend: false,
        filters: {
          "push_notifications": 1
        },
        companies: [],
        warnings: []
      }
    },
    computed: {
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      updateMessage(message) {
        this.handleWarnings(message);
        this.message = message;
      },
      updateUserIds(userIds) {
        this.userIds = userIds;
      },
      updateNotificationType(notificationType) {
        this.notificationType = notificationType;
      },
      async getFilteredUserIds() {
        this.disableSend = true;
        this.userIds = await consoleAPI.fetchUserIds(this.filters);
        this.disableSend = false;
        return this.userIds;
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
      showDialog(success, title, body) {
        this.$vs.dialog({
          color: success ? 'success' : 'danger',
          acceptText: 'OK',
          title: title,
          text: body,
        });
      },
      buildPushMessages() {
        let incrementIndex = 10000;
        let startIndex = 0;
        let endIndex = 10000;
        let notifications = [];

        while (startIndex < this.fcmTokens.length) {
          const result = helpers.fcmHelpers.makeSendNotificationMessage(this.message, this.fcmTokens.slice(startIndex, endIndex), this.notificationType);
          console.log("result", result);
          notifications = [...notifications, ...result];
          startIndex = startIndex + incrementIndex;
          endIndex = endIndex + incrementIndex;
        }

        return notifications;
      },
      confirmAction(title, body, action) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'YES',
          title: title,
          text: body,
          accept: () => {
            action();
          }
        });
      },
      async fetchTokens() {
        let incrementIndex = 10000;
        let startIndex = 0;
        let endIndex = incrementIndex;
        let results = [];
        let fcmTokens = [];

        while (startIndex < this.userIds.length) {
          let result = request.post(`${request.getApiV3Url()}admin/fcm/by-users`, { user_ids: this.userIds.slice(startIndex, endIndex) });
          results.push(result);
          startIndex = startIndex + incrementIndex;
          endIndex = endIndex + incrementIndex;
        }

        const responses = await Promise.all(results);
        responses.forEach((response) => {
          if(Object.prototype.hasOwnProperty.call(response, 'data') && Array.isArray(response.data.tokens)) {
            fcmTokens = fcmTokens.concat(response.data.tokens);
          }
        });

        if (fcmTokens.length) {
          this.fcmTokens = fcmTokens;
          return true;
        } else {
          this.showDialog(false, 'Error fetching fcm tokens', JSON.stringify(responses));
          return false;
        }
      },
      async sendPushes(dryRun = false) {
        this.isLoading = true;
        this.disableSend = true;
        try {
          if (await this.fetchTokens()) {
            let response = await api.sendPushes(this.buildPushMessages(), dryRun);
            if (response.successCount > 0) {
              const count = this.notificationType === 'notification-data' ? response.successCount / 2 : response.successCount;
              this.showDialog(true, 'Success', `Messages ${dryRun ? 'can be ' : 'successfully '} sent to ${count} devices`);
            } else {
              this.showDialog(false, `Failure`, `No messages ${dryRun ? 'can be ' : 'successfully '} sent`);
            }
          }
        } catch (e) {
          this.showDialog(false, `Failure`, `No messages ${dryRun ? 'can be ' : 'successfully '} sent`);
        } finally {
          if (!dryRun) await this.createHistoryLog();
          this.disableSend = false;
          this.isLoading = false;
        }
      },

      async createHistoryLog() {
        let filters = [];

        Object.entries(this.filters).forEach(([key, value]) => {
          if (key === "push_notifications") return;
          if (Array.isArray(value) ) {
            if (key === "company") filters.push(`${key}: ${this.companies.filter(company => value.includes(company.value)).map(company => company.label).join(', ')}`);
            else filters.push(`${key}: ${value.join(', ')}`);
          }
          else filters.push(`${key}: ${value}`);
        });

        let data = {
          notificationType: this.notificationType,
          messageTitle: this.message.title,
          messageBody: this.message.message,
          webLink: this.message.link,
          filters: filters,
          userIds: filters.length ? [] : this.userIds
        }

        await consoleAPI.createPushNotificationLog(data);
      },

      async getCompanies() {
        let companies = await consoleAPI.fetchActiveCompanies();
        companies = companies.map((company) => {
          return {
            label: company.name,
            value: company.company_id,
          }
        });
        this.companies = companies;
      },

      setIsLoading(b) {
        this.isLoading = b;
      },

      handleWarnings(message) {
        const existingWarnings = this.warnings.map(warning => warning.field);

        if (message.title.length >= 35 && !existingWarnings.includes('title') ) {
          this.warnings.push({field: 'title', text: `Waring: IOS starts to truncate text at ~40+ chars.`});
        }
        else if (existingWarnings.length && message.title.length < 35) this.clearWarning('title');

        if (message.message.length >= 190 && !existingWarnings.includes('message')) {
          this.warnings.push({field: 'message', text: `Waring: IOS starts to truncate text at ~200+ chars.`});
        }
        else if (existingWarnings.length && message.message.length < 190) this.clearWarning('message')
      },

      clearWarning(field) {
        this.warnings = this.warnings.filter(warning => warning.field !== field);
      }
    },
  }

</script>


<style lang="scss">
  #main-container {

    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

